import { Platform } from '@angular/cdk/platform';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker';

import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@next/core-lib/i18n';

import { CustomDateAdapter } from './custom-date-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMMM YYYY',
  },
  display: {
    dateInput: 'MMMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE, Platform],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    TranslatePipe,
  ],
})
export class MonthPickerComponent implements OnInit {
  @Output()
  dateChanged = new EventEmitter<string>();
  @Input()
  validDateFrom: Date;
  @Input()
  validDateTo: Date;
  public date = new FormControl(
    new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0)),
  );

  ngOnInit(): void {
    this.date.disable();
  }

  public onDateChanged(value: Date) {
    console.log(value);
  }

  public dateFilter = (date: Date): boolean => {
    if (this?.validDateTo === undefined && this.validDateFrom === undefined) {
      return true;
    }

    if (this.validDateFrom === undefined) {
      return date < this.validDateTo;
    }

    if (this.validDateTo === undefined) {
      return this.validDateFrom < date;
    }

    return date < this.validDateTo && this.validDateFrom < date;
  };

  chosenYearHandler(normalizedYear: Date) {
    const ctrlValue = this.date.value as Date;
    ctrlValue.setFullYear(normalizedYear.getFullYear());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    const ctrlValue = this.date.value as Date;
    ctrlValue.setMonth(normalizedMonth.getMonth());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.dateChanged.emit(this.getYearMonth(this.date.value));
  }

  private getYearMonth(date: Date): string {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)).toISOString();
  }
}
